<template lang="pug">
v-container.mb-6
    v-row 
        v-col(cols="12")
            v-card.rounded-lg.elevation-25.pa-4
                div(v-if="themes && themes.length > 0 && selectedTheme")
  
                  v-row
                    v-col(cols="12" md="6")
                      div(style="width: 100%")
                          v-card-title {{$t('create.addInformation.title')}}
                          v-card-subtitle 
                            | {{$t('create.addInformation.subtitle')}} 
                          v-card-text(style="width: 100%")
                            MotionForm
                    v-col(cols="12" md="6")  
                      MotionPlayer
                div(v-else style="height: 100%; width: 100%; min-width: 100px; min-height: 300px" )
                  v-skeleton-loader( style="opacity: 1; height: 100%; width: 100%; min-width: 100px; min-height: 300px" type="image"  min-height="300")
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { mapFields, mapMultiRowFields } from "vuex-map-fields";
import OverlayPlayer from "@/components/player/OverlayPlayer";
import MotionPlayer from "@/components/player/MotionPlayer";
import MotionForm from "@/components/create/MotionForm";
import { EventBus } from "@/event-bus";

export default {
  components: {
    OverlayPlayer,
    MotionPlayer,
    MotionForm,
  },
  data() {
    return {
      drag: false,
      currentTimePosition: "00:00",
      isPlaying: false,
      currentOverlay: null,
      ready: false,
    };
  },
  computed: {
    ...mapFields("create", {
      isCreating: "isCreating",
      includeIntro: "motionSettings.includeIntro",
      selectedTheme: "selectedTheme",
      selectedElement: "selectedElement",
      overlay: "selectedTheme.overlay",
    }),
    ...mapMultiRowFields("create", {
      timelineElements: "timelineElements",
    }),
    ...mapState({
      categories: (state) => state.settings.categories,
      themes: (state) => state.create.themes,
    }),
    ...mapGetters({
      intro: "create/intro",
      outro: "create/outro",
    }),
    timelineElements: {
      // getter
      get: function () {
        return this.$store.state.create.timelineElements;
      },
      // setter
      set: function (newValue) {
        return this.$store.commit("create/set_timeline_elements", newValue);
      },
    },
  },
  methods: {
    updateOverlay() {
      this.$emit("updateOverlay", this.selectedTheme.overlay);
    },
    getLabel(input) {
      const translations = input.translation;
      if (!translations) {
        return this.$i18n.t(`general.${input.key.toLowerCase()}`);
      } else {
        const currentLocale = this.$i18n.locale;
        return translations[currentLocale];
      }
    },
    playTimeline() {
      if (this.isPlaying) {
        this.isPlaying = false;
        EventBus.$emit("pause", this.selectedElement);
      } else {
        this.isPlaying = true;
        EventBus.$emit("play", this.selectedElement);
      }
    },
    donePlaying(item) {
      this.isPlaying = false;
      const currentIndex = this.timelineElements.findIndex(
        (el) => el.id === item.id
      );
      const nextItem = this.timelineElements[currentIndex + 1];
      if (nextItem) {
        this.selectedElement = nextItem;
        EventBus.$emit("play", nextItem);
        this.isPlaying = true;
      }
    },
  },
};
</script>
